import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_PRODUCT_LINES_FOR_LEGACY_ACTIVATION_RETRIEVAL: createAsyncMutation('GET_PRODUCT_LINES_FOR_LEGACY_ACTIVATION_RETRIEVAL'),
    GET_PRODUCTS_FOR_PURCHASE: createAsyncMutation('GET_PRODUCTS_FOR_PURCHASE'),
}

const product = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getProductLinesForLegacyActivationRetrieval(store) {
            let url = api.product + 'LegacyActivationRetrievalProducts'
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCT_LINES_FOR_LEGACY_ACTIVATION_RETRIEVAL })
        },
        getProductsForPurchase(store, payload) {
            let url = api.product + 'PurchaseList'
            if (payload) url += '?productCategoryId=' + payload.id
            else url += '?productCategoryId='
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCTS_FOR_PURCHASE })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default product
